import MentoringSmallText from './MentoringSmallText.vue';

export default MentoringSmallText;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/smalltext/index.ts